import React from 'react';
import Icon from '../../../components/AppIcon';

const PlayerDocumentCard = ({ player, isSelected, onSelect, completionPercentage }) => {
  const getStatusColor = () => {
    if (completionPercentage === 100) return 'text-success';
    if (completionPercentage > 0) return 'text-warning';
    return 'text-muted-foreground';
  };

  const getStatusIcon = () => {
    if (completionPercentage === 100) return 'CheckCircle2';
    if (completionPercentage > 0) return 'Clock';
    return 'AlertCircle';
  };

  return (
    <button
      onClick={onSelect}
      className={`w-full p-4 rounded-lg border-2 transition-all duration-200 text-left ${
        isSelected
          ? 'border-primary bg-primary/5' :'border-border bg-card hover:border-primary/50'
      }`}
    >
      <div className="flex items-start gap-3">
        <div className="relative flex-shrink-0">
          <div className="w-12 h-12 bg-gradient-to-br from-blue-500 to-indigo-600 rounded-full flex items-center justify-center text-white font-bold text-sm">
            {player?.name?.charAt(0)?.toUpperCase() || 'P'}
          </div>
          <div
            className={`absolute -bottom-1 -right-1 w-5 h-5 rounded-full bg-background flex items-center justify-center ${getStatusColor()}`}
          >
            <Icon name={getStatusIcon()} size={14} />
          </div>
        </div>

        <div className="flex-1 min-w-0">
          <h3 className="font-semibold text-sm text-foreground truncate">
            {player?.name}
          </h3>
          <p className="text-xs text-muted-foreground mt-0.5">
            {player?.role} • {player?.mcaId}
          </p>

          <div className="mt-2 flex items-center gap-2">
            <div className="flex-1 h-1.5 bg-muted rounded-full overflow-hidden">
              <div
                className={`h-full transition-all duration-300 ${
                  completionPercentage === 100
                    ? 'bg-success'
                    : completionPercentage > 0
                    ? 'bg-warning' :'bg-muted-foreground'
                }`}
                style={{ width: `${completionPercentage}%` }}
              />
            </div>
            <span className={`text-xs font-medium ${getStatusColor()}`}>
              {completionPercentage}%
            </span>
          </div>
        </div>
      </div>
    </button>
  );
};

export default PlayerDocumentCard;